<div class="avatar" [ngStyle]="{ 'background-color': name == 'System '? '#fff':backgroundColor }">
  <ng-container *ngIf="name != 'System '">
    {{ name | initials }}
  </ng-container>
  <img src="assets/images/logo/logo.mini.png" style="max-width: 100%;" alt="" *ngIf="name == 'System '">
</div>